module.exports = __webpack_public_path__ + "static/media/480.3277181c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-grass/dark/480.png
// module id = 2120
// module chunks = 2